import React from 'react';

const Services = () => {
    return (
        <div id='service' className='mx-12 py-32 '>
            <h2 className='text-3xl text-center font-bold my-4'> My Services</h2>
            

            <div className='grid sm:grid-cols-1 lg:grid-cols-3 gap-6'>
{/* ----------------- */}
                <div className='md:flex items-center bg-[#090222] px-3 py-8'>
                    <div className='text-white text-5xl mr-2'>
                    <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div>
                        <h1 className='text-2xl'>Frontend Development</h1>
                        <p className='text-sm'>I will provide modern react frontend UI</p>
                    </div>
           </div>
                
{/* ---------------- */}
{/* ----------------- */}
                <div className='md:flex items-center bg-[#090222] px-3 py-8'>
                    <div className='text-white text-5xl mr-2'>
                    <ion-icon name="code-slash-outline"></ion-icon>
                    </div>
                    <div>
                        <h1 className='text-2xl'>Backend Development</h1>
                        <p className='text-sm'>Backend development using ExpressJs[JavaScript],database store mongodb</p>
                    </div>
           </div>
                
{/* ---------------- */}
{/* ----------------- */}
                <div className='md:flex items-center bg-[#090222] px-3 py-8'>
                    <div className='text-white text-5xl mr-2'>
                    <ion-icon name="phone-portrait-outline"></ion-icon>
                    </div>
                    <div>
                        <h1 className='text-2xl'>Responsive Design</h1>
                        <p className='text-sm'>I will provide mobile first look UI ,also suitable for medium and large screen.</p>
                    </div>
           </div>
                
{/* ---------------- */}








            </div>
        </div>
    );
};

export default Services;